import React from 'react';
import dayjs from 'dayjs';
import DataGrid from '../../../../common/DataGrid/DataGrid';
import { useTranslation } from 'react-i18next';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter';

const PhdDissertationDefenseExaminerProposalsTable = ({
  dissertationDefenseExaminerProposals,
  onDetailClick,
  onDelete,
  pagination,
  onPaginationChange,
}) => {
  const { t } = useTranslation();

  const studentFilter = useDataGridTextFilter('student_display_name');
  const profFilter = useDataGridTextFilter('prof_opponent_display_name');
  const qualifiedFilter = useDataGridTextFilter(
    'qualified_opponent_display_name',
  );
  const updatedByFilter = useDataGridTextFilter('updated_by_name');

  const columns = [
    {
      title: t('Študent'),
      dataIndex: 'student_display_name',
      key: 'student_display_name',
      ellipsis: true,
      ...studentFilter,
    },
    {
      title: t('Profesor oponent'),
      dataIndex: 'prof_opponent_display_name',
      key: 'prof_opponent_display_name',
      ellipsis: true,
      ...profFilter,
    },
    {
      title: t('Kvalifikovaný oponent'),
      dataIndex: 'qualified_opponent_display_name',
      key: 'qualified_opponent_display_name',
      ellipsis: true,
      ...qualifiedFilter,
    },
    {
      title: t('Počet kreditov'),
      dataIndex: 'credits_count',
      key: 'credits_count',
      ellipsis: true,
    },
    {
      title: t('Rok podania'),
      dataIndex: 'application_year',
      key: 'application_year',
      ellipsis: true,
    },
    {
      title: t('Naposledy upravené'),
      dataIndex: 'updated_at',
      key: 'updated_at',
      ellipsis: true,
      render: (value) =>
        value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '—',
    },
    {
      title: t('Upravil'),
      dataIndex: 'updated_by_name',
      key: 'updated_by_name',
      ellipsis: true,
      render: (value) => value || '—',
      ...updatedByFilter,
    },
  ];

  return (
    <DataGrid
      locale={{
        emptyText: t(
          'Pre zvolený pohľad a filtre nie sú dostupné žiadne záznamy.',
        ),
      }}
      rowKey={(proposal) => proposal.id}
      columns={columns}
      dataSource={dissertationDefenseExaminerProposals || []}
      permissionsBasic={'phd-dissertation-defense-examiner-proposals'}
      uniqueTableId={'phd-dissertation-defense-examiner-proposals-table'}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
      secondaryCondition={(row) => row.can_edit !== false}
      deleteCondition={(row) => row.can_delete !== false}
      editDisabledTooltip={t('Archivovaný záznam je iba na čítanie')}
      deleteDisabledTooltip={t('Archivovaný záznam nie je možné vymazať')}
      pagination={pagination}
      onChange={onPaginationChange}
    />
  );
};

export default PhdDissertationDefenseExaminerProposalsTable;
